/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback } from 'react';
// redux
// material
import {Switch, CheckboxField } from '@insticator/insticator-ui';
import SectionGroup from 'material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription
    from 'material/expandablesection/sectiongroupdescription/sectiongroupdescription';
// styles
import injectSheet from 'react-jss';
import styles from './aboutsection_styles';
import PreviewConfig from 'pages/dashboard/commenting/commentingconfigv2/previewconfig/previewconfig';
import { url } from 'utils/urls';


const aboutSectionOptionsMap = {
    BIO: 'Bio',
    PLACES_OF_RESIDENCE: `Places I've lived`,
    OCCUPATIONS: 'Occupation(s)',
    ACCOMPLISHMENTS: 'Accomplishments',
    INTERESTS: 'Interests',
    OTHER_INTERESTS: 'Other interests'
}

/* ========== ~~~~~~~~~~ ADVANCED SETTINGS - SENTIMENT ~~~~~~~~~~ ========== */
const AboutSection = injectSheet(styles)((props) => {

    const { useAbout, aboutSectionOptions, onChange } = props

    const handleAboutOptionChange = useCallback((property, value) => {
        const currentAboutOptions = [...aboutSectionOptions]
        let newAboutOptionsList = [...currentAboutOptions]
        if(!value) newAboutOptionsList = currentAboutOptions.filter(aboutOpt => aboutOpt !== property)
        else newAboutOptionsList.push(property)
        onChange({'aboutSectionOptions': newAboutOptionsList, useAbout: newAboutOptionsList.length ? useAbout : false })
    },[aboutSectionOptions, onChange])

    const handleChangeAboutToggle = useCallback((enableAbout) => {
        let newAboutOptionsList = [...aboutSectionOptions]
        if(!enableAbout) newAboutOptionsList = []
        else {
            if(newAboutOptionsList.length === 0) newAboutOptionsList = ['BIO', 'PLACES_OF_RESIDENCE', 'OCCUPATIONS', 'ACCOMPLISHMENTS', 'INTERESTS', 'OTHER_INTERESTS']
        }
        onChange({'useAbout': enableAbout, 'aboutSectionOptions': newAboutOptionsList})
    }, [aboutSectionOptions, onChange])

  
    const isAboutOptionEnabled = (option) =>  aboutSectionOptions && aboutSectionOptions.length ? aboutSectionOptions.includes(option) : false

    return (
        <div id="about-config">
            <SectionGroup row klass={'aboutsectioncontainer'}>
                <SectionGroup>
                    <SectionGroup>
                        <SectionGroupDescription
                            title={'Story'}
                            description={''}
                        />
                    </SectionGroup>
                    <SectionGroup row>
                        <Switch variant={'primary'} handleClick={() => handleChangeAboutToggle(!useAbout)}
                                on={useAbout}/>
                        <SectionGroupDescription
                            title={'Allow users to add a story section to their profile'}
                            description={''}
                        />
                    </SectionGroup>
                    <SectionGroup child>
                    {Object.keys(aboutSectionOptionsMap).map(key => (
                        <CheckboxField type={`checkbox`}
                            name={`aboutoption`}
                            valid={true}
                            checked={isAboutOptionEnabled(key)}
                            disabled={!useAbout}
                            handleChange={() => handleAboutOptionChange(key, !isAboutOptionEnabled(key))}
                            label={aboutSectionOptionsMap[key]}
                        />
                    ))}
                    </SectionGroup>
                </SectionGroup>
                <PreviewConfig>
                    <img src={`${url.image}/2.0/profile-story-preview.png`} alt="" width={320} />
                </PreviewConfig>
            </SectionGroup>
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AboutSection;

